import storeRedirect from './store-redirect';

export default {
  storeRedirect,
};
